import { render, staticRenderFns } from "./AdminView.vue?vue&type=template&id=798f68c8&"
import script from "./AdminView.vue?vue&type=script&lang=js&"
export * from "./AdminView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports